function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M30.441,36.61c3.506,9.069,10.104,15.029,18.587,15.029c8.103,0,15.125-5.735,18.59-15.029 c3.64-0.339,5.546-3.852,6.256-7.995c0.846-4.951-0.931-7.367-4.063-7.908C68.744,9.078,65.401,0,49.028,0 c-16.47,0-19.72,9.078-20.786,20.707c-3.132,0.541-4.91,2.957-4.063,7.908C24.896,32.806,26.87,36.299,30.441,36.61z  M39.43,27.177c1.887-0.625,3.601-1.453,5.128-2.369c0.945,0.439,1.606,1.392,1.606,2.501c0,1.522-1.24,2.764-2.764,2.764h-1.221 c-1.523,0-2.764-1.24-2.764-2.764C39.416,27.264,39.428,27.222,39.43,27.177z M37.459,27.729c0.216,2.428,2.238,4.344,4.721,4.344 h1.221c2.627,0,4.764-2.137,4.764-4.764c0-0.26-0.036-0.51-0.076-0.758h1.882c-0.04,0.248-0.076,0.498-0.076,0.758 c0,2.627,2.137,4.764,4.764,4.764h1.221c2.627,0,4.764-2.137,4.764-4.764c0-2.627-2.137-4.764-4.764-4.764h-1.222 c-1.598,0-3.005,0.796-3.87,2.006h-3.517c-0.252-0.354-0.556-0.665-0.892-0.938c3.636-2.573,5.908-5.384,6.486-6.146 c1.029,2.062,3.973,6.094,11.641,7.905c-0.723,11.938-7.008,20.376-15.478,20.376c-7.977,0-13.56-7.346-15.138-17.466 C35.134,28.196,36.32,27.998,37.459,27.729z M51.894,27.309c0-1.523,1.24-2.764,2.765-2.764h1.221c1.523,0,2.764,1.24,2.764,2.764 c0,1.524-1.239,2.764-2.764,2.764h-1.221C53.134,30.073,51.894,28.833,51.894,27.309z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.581,83.67c-1.142-22.078-9.427-33.12-17.411-37.941c-0.004-0.004-0.009-0.007-0.017-0.012L53.64,68.453l-1.205-4.313 c1.131-0.979,1.862-2.407,1.862-4.022c0-2.953-2.393-5.346-5.345-5.346s-5.191,2.393-5.191,5.346c0,1.615,0.732,3.043,1.861,4.022 l-1.274,4.313l-12.46-22.725c-8.034,4.766-16.267,15.715-17.411,37.939c-0.204,3.927,2.434,7.295,5.892,7.522 c0.124,0.01,6.768,0.348,6.768,0.348c4.133,4.689,12.635,6.521,22.04,6.521c9.98,0,17.805-2.19,21.742-6.521 c0,0,6.642-0.338,6.766-0.348C81.143,90.963,83.783,87.594,83.581,83.67z M68.586,76.68h-9.438v-4.129h9.438V76.68z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgProfessor = function SvgProfessor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "98.058px",
    height: "98.058px",
    viewBox: "0 0 98.058 98.058",
    style: {
      enableBackground: "new 0 0 98.058 98.058"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfessor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/professor.2771ce72.svg";
export { ForwardRef as ReactComponent };